import tripsService from "../shared/services/tripsService";

const REQUEST_CREATE_TRIP = "REQUEST_CREATE_TRIP";
const RESPONSE_CREATE_TRIP = "RESPONSE_CREATE_TRIP";
const REQUEST_CREATE_TRIP_FAILURE = "REQUEST_CREATE_TRIP_FAILURE";

const requestCreateTripAction = () => {
  return {
    type: REQUEST_CREATE_TRIP,
  };
};

const responseCreateTripAction = (data, routeId) => {
  return {
    type: RESPONSE_CREATE_TRIP,
    data,
    routeId,
  };
};

const requestCreateTripFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_TRIP_FAILURE,
    errors,
  };
};

const createTrip = (options) => {
  return (dispatch) => {
    dispatch(requestCreateTripAction());

    tripsService
      .createTrip(options)
      .then((result) => {
        result.data.unit = null;
        dispatch(responseCreateTripAction(result.data, options.routeId));
      })
      .catch((error) => {
        dispatch(requestCreateTripFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_TRIP = "REQUEST_DELETE_TRIP";
const RESPONSE_DELETE_TRIP = "RESPONSE_DELETE_TRIP";
const REQUEST_DELETE_TRIP_FAILURE = "REQUEST_DELETE_TRIP_FAILURE";

const requestDeleteTripAction = () => {
  return {
    type: REQUEST_DELETE_TRIP,
  };
};

const responseDeleteTripAction = (data, routeId) => {
  return {
    type: RESPONSE_DELETE_TRIP,
    data,
    routeId,
  };
};

const requestDeleteTripFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_TRIP_FAILURE,
    errors,
  };
};

const deleteTrip = (options, routeId) => {
  return (dispatch) => {
    dispatch(requestDeleteTripAction());

    tripsService
      .deleteTrip(options)
      .then((result) => {
        dispatch(responseDeleteTripAction(options, routeId));
      })
      .catch((error) => {
        dispatch(requestDeleteTripFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_TRIP_CONTROL_POINTS = "REQUEST_UPDATE_TRIP_CONTROL_POINTS";
const RESPONSE_UPDATE_TRIP_CONTROL_POINTS = "RESPONSE_UPDATE_TRIP_CONTROL_POINTS";
const REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE = "REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE";

const requestUpdateTripControlPointsAction = () => {
  return {
    type: REQUEST_UPDATE_TRIP_CONTROL_POINTS,
  };
};

const responseUpdateTripControlPointsAction = (data, routeId) => {
  return {
    type: RESPONSE_UPDATE_TRIP_CONTROL_POINTS,
    data,
    routeId,
  };
};

const requestUpdateTripControlPointsFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE,
    errors,
  };
};

const updateTripControlPoints = (options, routeId, trip) => {
  return (dispatch) => {
    dispatch(requestUpdateTripControlPointsAction());

    tripsService
      .updateTripControlPoints(options)
      .then((result) => {
        dispatch(responseUpdateTripControlPointsAction(trip, routeId));
      })
      .catch((error) => {
        dispatch(requestUpdateTripControlPointsFailureAction(error.response));
      });
  };
};

const ON_SELECT_TRIP = "ON_SELECT_TRIP";

const onSelectTripAction = (data) => {
  return {
    type: ON_SELECT_TRIP,
    data,
  };
};

const selectTrip = (data) => {
  return (dispatch) => {
    dispatch(onSelectTripAction(data));
  };
};

const ON_UNSELECT_TRIP = "ON_UNSELECT_TRIP";

const onUnselectTripAction = () => {
  return {
    type: ON_UNSELECT_TRIP,
  };
};

const unselectTrip = () => {
  return (dispatch) => {
    dispatch(onUnselectTripAction());
  };
};

const REQUEST_CREATE_TRIP_UNIT = "REQUEST_CREATE_TRIP_UNIT";
const RESPONSE_CREATE_TRIP_UNIT = "RESPONSE_CREATE_TRIP_UNIT";
const REQUEST_CREATE_TRIP_UNIT_FAILURE = "REQUEST_CREATE_TRIP_UNIT_FAILURE";

const requestCreateTripUnitAction = () => {
  return {
    type: REQUEST_CREATE_TRIP_UNIT,
  };
};

const responseCreateTripUnitAction = (data, unit, routeId) => {
  return {
    type: RESPONSE_CREATE_TRIP_UNIT,
    data,
    unit,
    routeId,
  };
};

const requestCreateTripUnitFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_TRIP_UNIT_FAILURE,
    errors,
  };
};

const createTripUnit = (options, unit, routeId) => {
  return (dispatch) => {
    dispatch(requestCreateTripUnitAction());

    tripsService
      .createTripUnit(options)
      .then((result) => {
        dispatch(responseCreateTripUnitAction(options, unit, routeId));
      })
      .catch((error) => {
        dispatch(requestCreateTripUnitFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_TRIP_UNIT = "REQUEST_DELETE_TRIP_UNIT";
const RESPONSE_DELETE_TRIP_UNIT = "RESPONSE_DELETE_TRIP_UNIT";
const REQUEST_DELETE_TRIP_UNIT_FAILURE = "REQUEST_DELETE_TRIP_UNIT_FAILURE";

const requestDeleteTripUnitAction = () => {
  return {
    type: REQUEST_DELETE_TRIP_UNIT,
  };
};

const responseDeleteTripUnitAction = (data, routeId) => {
  return {
    type: RESPONSE_DELETE_TRIP_UNIT,
    data,
    routeId,
  };
};

const requestDeleteTripUnitFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_TRIP_UNIT_FAILURE,
    errors,
  };
};

const deleteTripUnit = (options, routeId) => {
  return (dispatch) => {
    dispatch(requestDeleteTripUnitAction());

    tripsService
      .deleteTripUnit(options)
      .then((result) => {
        dispatch(responseDeleteTripUnitAction(options.tripId, routeId));
      })
      .catch((error) => {
        dispatch(requestDeleteTripUnitFailureAction(error.response));
      });
  };
};

export {
  REQUEST_CREATE_TRIP,
  RESPONSE_CREATE_TRIP,
  REQUEST_CREATE_TRIP_FAILURE,
  createTrip,
  REQUEST_DELETE_TRIP,
  RESPONSE_DELETE_TRIP,
  REQUEST_DELETE_TRIP_FAILURE,
  deleteTrip,
  REQUEST_UPDATE_TRIP_CONTROL_POINTS,
  RESPONSE_UPDATE_TRIP_CONTROL_POINTS,
  REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE,
  updateTripControlPoints,
  ON_SELECT_TRIP,
  selectTrip,
  ON_UNSELECT_TRIP,
  unselectTrip,
  REQUEST_CREATE_TRIP_UNIT,
  RESPONSE_CREATE_TRIP_UNIT,
  REQUEST_CREATE_TRIP_UNIT_FAILURE,
  createTripUnit,
  REQUEST_DELETE_TRIP_UNIT,
  RESPONSE_DELETE_TRIP_UNIT,
  REQUEST_DELETE_TRIP_UNIT_FAILURE,
  deleteTripUnit,
};
